<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-8">
            <table>
              <tr>
                <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                </td>
                <td>
                  <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">All Branch</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                </td>
                <td>
                  <b-form-select name="sales" v-model="sales_id" @change="changeSales">
                    <option :value="null">All MA</option>
                    <option v-for="item in dataSales" :key="item.id" :value="item.id">{{ item.fullname }}</option>
                  </b-form-select>
                </td>
                <td>
                  <b-form-input v-model="keyword" @keyup.enter="fetchData" placeholder="Search name, phone, email, PT"
                    class="font-13"></b-form-input>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table :busy="loadingActive" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items" :fields="fields" :per-page="perPage"
          :current-page="currentPage">
        </b-table>
        <b-pagination v-if="items.length > perPage" class="pagination-custom mt-20" v-model="currentPage"
          :total-rows="items.length" :per-page="perPage"></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'sessionExpiredReport',
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      fields: [
        { key: 'club', label: 'Club', sortable: true },
        { key: 'trx_id', label: 'TRX ID', sortable: true },
        { key: 'member_name', label: 'Member Name', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'phone_number', label: 'Phone Number', sortable: true },
        { key: 'ma_name', label: 'MA', sortable: true },
        { key: 'membership_type', label: 'Membership Type', sortable: true },
        { key: 'package_name', label: 'Package Name', sortable: true },
        { key: 'package_status', label: 'Package Status', sortable: true },
        {
          key: 'session_expired_date',
          label: 'Session Expired Date',
          sortable: true,
          formatter: (value) => value ? moment(value).format('DD MMMM YYYY') : '-'
        },
        { key: 'pt_name', label: 'PT Name', sortable: true }
      ],
      items: [],
      currentPage: 1,
      perPage: 20,
      branch_id: null,
      sales_id: null,
      keyword: '',
      dataBranch: [],
      dataSales: []
    }
  },
  methods: {
    exportReport() {
      this.loadingActive = true
      let url = 'crm/v1/export/report/session_expired?'
      if (this.branch_id != null) {
        url += 'branch_id=' + this.branch_id + '&'
      }
      if (this.sales_id != null) {
        url += 'sales_id=' + this.sales_id + '&'
      }
      if (this.keyword) {
        url += 'keyword=' + this.keyword
      }
      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Report Session Expired ' + moment().format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    changeBranch() {
      this.fetchData()
    },
    changeSales() {
      this.fetchData()
    },
    fetchData() {
      this.loadingActive = true
      this.currentPage = 1
      let url = 'crm/v1/session_expired_report?'
      if (this.branch_id != null) {
        url += 'branch_id=' + this.branch_id + '&'
      }
      if (this.sales_id != null) {
        url += 'sales_id=' + this.sales_id + '&'
      }
      if (this.keyword) {
        url += 'keyword=' + this.keyword
      }
      axios.get(url).then(response => {
        this.items = response.data.data.map(el => ({
          club: el.branch ? el.branch.codename : '-',
          trx_id: el.trx_id,
          member_name: el.member_name,
          email: el.email,
          phone_number: el.phone_number,
          ma_name: el.ma_name,
          membership_type: el.membership_type,
          package_name: el.package_name,
          package_status: el.package_status,
          session_expired_date: el.session_expired_date,
          pt_name: el.pt_name
        }))
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('crm/v1/sales?sorting=fullname&sorting_type=asc').then(response => {
        this.dataSales = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style></style>
